module.exports = __webpack_public_path__ + "img/mobile/SmartButton-auto/auto_bg@3x.png?0.0.53";